module.exports = __webpack_public_path__ + "static/img/pic-cnt-active-2.0a70bed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/en/pic-cnt-active-2.png
// module id = 8xEK
// module chunks = 0